
export const AverageAndMedianRemuneration = `EmploymentEquity/AverageAndMedianRemuneration`;
export const GetReport = AverageAndMedianRemuneration;
export const SaveReport = AverageAndMedianRemuneration;
export const RecalculateTopBottomMedianEarnerValues = AverageAndMedianRemuneration + '/RecalculateEarnerValues/{ScorecardId}';
export const TopOrBottomEarners = AverageAndMedianRemuneration + '/TopOrBottomEarners/{ScorecardId}';
export const TopOrBottomEarnersRange = AverageAndMedianRemuneration + '/TopOrBottomEarnersRange/{ScorecardId}';
export const MedianEarners = AverageAndMedianRemuneration + '/MedianEarners/{ScorecardId}';
export const SaveUserCapturedValues = AverageAndMedianRemuneration + '/SaveUserCapturedValues/{ScorecardId}';